import { Skeleton } from "@dash/skeleton";
import { css, useTheme } from "@emotion/react";

import { DefaultAvatar } from "./DefaultAvatar";

type Props = {
  src: string | null | undefined;
  className?: string;
  size?: string;
};

export const Avatar: React.FC<Props> = (props) => {
  const theme = useTheme();
  const size = props.size ?? "30px";
  const shellCss = css({
    borderRadius: "50%",
    width: size,
    height: size,
    overflow: "hidden",
    flexShrink: 0,
    boxSizing: "border-box",
  });

  if (props.src === null) {
    return (
      <div className={props.className} css={css(shellCss, { border: `1px ${theme.colors.border} dashed` })} />
    );
  }

  if (props.src === undefined) {
    return <Skeleton className={props.className} css={shellCss} />;
  }

  if (props.src === "") {
    return <DefaultAvatar pxSize={parseInt(props.size ?? "30px", 10)} />;
  }

  return (
    <div className={props.className} css={shellCss}>
      <img
        alt=""
        src={props.src}
        css={css({
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "cover",
          objectPosition: "center",
        })}
      />
    </div>
  );
};
